export var ERROR_FETCHING_EVENTS = function ERROR_FETCHING_EVENTS(error) {
  return "Unable to fetch events: " + error;
};
export var MISSING_PARAMETERS = function MISSING_PARAMETERS(param) {
  return "Missing parameter " + param;
};
export var CONTRACT_ERROR = function CONTRACT_ERROR(error) {
  return "Contract Error: " + error;
};
export var HTTP_ERROR = function HTTP_ERROR(error) {
  return "HTTP Error: " + error;
};
export var VALIDATION_ERROR = function VALIDATION_ERROR(error) {
  return "Data Validation Error: " + error;
};
export var PARAMETER_ERROR = function PARAMETER_ERROR(error) {
  return "Parameter error: " + error;
};